export const colors = {
  blue: {
    deep: 'rgb(0, 121, 191)',
    light: 'rgba(0, 0, 0, 0.03)',
    lighter: 'rgba(0, 0, 0, 0.03)',
  },
  black: '#4d4d4d',
  shadow: 'rgba(0,0,0,0.2)',
  grey: '#E2E4E6',
  green: 'rgba(0, 0, 0, 0.03)',
  white: 'white',
  purple: 'rebeccapurple',
};

export const grid = 8;

export const borderRadius = 2;



// WEBPACK FOOTER //
// ./src/containers/Dashboard/constants.js